import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import ClienteList from '../views/cadastros/clientes/List.vue';
import EstabelecimentoList from '../views/cadastros/estabelecimento/List.vue';

let clienteRoutes = {
        path: "/cliente",
        component: DashboardLayout,
        name: "Cliente",
        icon: "perm_identity",
        redirect: "/cliente/cadastro",
        children: [
                {
                        path: "cadastro",
                        name: "Cliente",
                        icon: "image",
                        components: { default: ClienteList }
                },
                {
                        path: "unidade",
                        name: "Unidade",
                        icon: "image",
                        components: { default: EstabelecimentoList }
                },


        ]
};

export default clienteRoutes;